import { AmenityResType } from "../pages/page-components/pkg-amenities/TabAddPkgAmenites";
import httpUtil from "../utils/http.util";

class PkgAmenitiesService {
  async updateAmenity(id: string, data: AmenityResType) {
    return await httpUtil.put("/pkgAmenity/update", id, data);
  }
  async deleteAmenity(id: string) {
    return await httpUtil.delete("/pkgAmenity/delete", id);
  }
}
export default new PkgAmenitiesService();
